
import type {
  Theme
} from '@mui/material';

export const useCartStyling = (theme: Theme) => ({
  productImageCell: {
    display: {
      xs: "none",
      sm: "none",
      md: "none",
      lg: 'table-cell',
      xl: 'table-cell',
    },
  },
  lineItemSubtotalCell: {
    display: {
      xs: "none",
      sm: "none",
      md: 'table-cell',
      lg: 'table-cell',
      xl: 'table-cell',
    },
  },
  cartDesktopActionsCell: {
    display: {
      xs: "none",
      sm: "none",
      md: 'table-cell',
      lg: 'table-cell',
      xl: 'table-cell',
    },
  },
  cartMobileActions: {
    display: {
      xs: "block",
      sm: "block",
      md: 'none',
      lg: 'none',
      xl: 'none',
    },
  },
  cartItemTable: {
    "& td": {
      fontSize: theme.typography.body1.fontSize,
      borderBottom: 'none',
      paddingLeft: {
        xs: 0,
        sm: 0,
        md: 'initial',
      },
      paddingRight: {
        xs: 0,
        sm: 0,
        md: 'initial',
      },
      paddingBottom: theme.spacing(2),
    },
    "& th": {
      fontSize: theme.typography.body1.fontSize,
      borderBottom: 'none',
      paddingLeft: {
        xs: 0,
        sm: 0,
        md: 'initial',
      },
      paddingRight: {
        xs: 0,
        sm: 0,
        md: 'initial',
      },
      paddingBottom: theme.spacing(2),
    }
  },
  tableFooter: {
    "& td": {
      paddingBottom: theme.spacing(0.2),
      fontSize: theme.typography.body1.fontSize,
      borderBottom: 'none',
    },
    "& th": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(0.2),
      fontSize: theme.typography.body1.fontSize,
      borderBottom: 'none',
    }
  }
})

